import { StockField } from '../models/stock-search.model'

export const STOCK_FRAGMENT = 'stock'
export const STOCK_DEFAULT_FIELDS: StockField[] = ['warehouse._id']
